"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CRadio = _interopRequireDefault(require("01_core/components/materials/CRadio"));
var _CodeConsts = require("01_core/constants/CodeConsts");
var _react = _interopRequireDefault(require("react"));
var _styles = require("@mui/material/styles");
var _KansaAnswerConsts = require("../../common/consts/KansaAnswerConsts");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ErrorText = (0, _styles.styled)('div')(_ref => {
  let {
    theme
  } = _ref;
  return {
    color: '#f44336',
    fontWeight: 'bold',
    fontSize: theme.typography.body2.fontSize
  };
});
const DispArea = (0, _styles.styled)('div')({});

/**
 * 確認結果（ラジオボタン）コンポーネント
 */
const KakuninKekka = props => {
  const {
    chosaNo,
    listState,
    labelYes,
    labelNo,
    onChange,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(DispArea, null, /*#__PURE__*/_react.default.createElement(_CRadio.default, {
    id: listState[chosaNo].kakuninKekkaCd,
    selectedId: _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1,
    onChange: () => {
      onChange(chosaNo, _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_1, listState[chosaNo].chosaColumnCd, listState[chosaNo].standardPoints, _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_YES);
    },
    label: labelYes,
    color: "secondary"
  }), /*#__PURE__*/_react.default.createElement(_CRadio.default, {
    id: listState[chosaNo].kakuninKekkaCd,
    selectedId: _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2,
    onChange: () => {
      onChange(chosaNo, _CodeConsts.CODE.KANSA_KKNN_RSLT.CODE_2, listState[chosaNo].chosaColumnCd, listState[chosaNo].standardPoints, _KansaAnswerConsts.CONSTS.UPDATE_KIND.RESULT_NO);
    },
    label: labelNo,
    color: "secondary"
  }), !!error && helperText && /*#__PURE__*/_react.default.createElement(ErrorText, null, helperText));
};
var _default = exports.default = KakuninKekka;